import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-popoveræ°æ³¡
 * 
 * ç¹å»/é¼ æ ç§»å¥åç´ ï¼å¼¹åºæ°æ³¡å¼çå¡çæµ®å±ã
 * 
 * å½ç®æ åç´ æè¿ä¸æ­¥çæè¿°åç¸å³æä½æ¶ï¼å¯ä»¥æ¶çº³å°å¡çä¸­ï¼æ ¹æ®ç¨æ·çæ	ä½è¡ä¸ºè¿è¡å±ç°ã
 * 
 * åÂ TooltipÂ çåºå«æ¯ï¼ç¨æ·å¯ä»¥å¯¹æµ®å±ä¸çåç´ è¿è¡æä½ï¼å æ­¤å®å¯ä»¥æ¿è½½æ´å¤	æçåå®¹ï¼æ¯å¦é¾æ¥ææé®ç­ã
 * 
 */
@Component({
    selector: 'fc-popover',
    template: `
    <nz-popover fcType={{fcType}} [nzTitle]="fcTitle" fcValue="fcValue" fcPopoverContent="fcPopoverContent" [nzPlacement]="fcPosition"  [nzTrigger]="fcTrigger" *ngIf="fcType==='text'">
    <button nz-button [nzType]="'primary'" nz-popover [nzSize]="fcSize">{{fcValue}}</button>
    <ng-template #nzTemplate>
      <div>
        <p class="fcPopoverContentfont">{{fcPopoverContent}}</p>
      </div>
    </ng-template>
    </nz-popover>
    <nz-popover [nzTitle]="fcTitle" fcValue="fcValue" fcPopoverContent="fcPopoverContent" *ngIf="fcIcon!==undefined"  [nzPlacement]="fcPosition"   [nzTrigger]="fcTrigger">
      <button nz-button [nzType]="'primary'" nz-popover [nzSize]="fcSize">
      <i class="icon iconfont {{fcIcon}}"></i>
      </button>
      <ng-template #nzTemplate>
        <div>
          <p class="fcPopoverContentfont">{{fcPopoverContent}}</p>
        </div>
      </ng-template>
    </nz-popover>
    <nz-popover [nzTitle]="fcTitle" fcShowClose="_showClose" fcPopoverContent="fcPopoverContent"  [nzPlacement]="fcPosition"  [(nzVisible)]="visible" [nzTrigger]="fcTrigger" 
    *ngIf="fcShowClose==='Y' && fcPopoverIcon===undefined">
        <button nz-button nz-popover [nzType]="'primary'" [nzSize]="fcSize">{{fcValue}}</button>
        <ng-template #nzTemplate>
        <a (click)='clickMe()' class="fcPopoverContentfont">{{fcPopoverContent}}</a>
        </ng-template>
    </nz-popover>
    <nz-popover [nzTitle]="fcTitle" fcShowClose="_showClose" fcPopoverIcon="fcPopoverIcon"  [nzPlacement]="fcPosition"  [(nzVisible)]="visible" [nzTrigger]="fcTrigger"
     *ngIf="fcShowClose==='Y' && fcPopoverIcon!==undefined">
        <button nz-button nz-popover [nzType]="'primary'" [nzSize]="fcSize">{{fcValue}}</button>
        <ng-template #nzTemplate>
        <span (click)='clickMe()' class="fcPopoverIconcolor">
        <i class="icon iconfont {{fcPopoverIcon}}"></i>
        </span>
        </ng-template>
    </nz-popover>
    `,
    styles: [`
        .fcPopoverContentfont{
            color:#666;
        }   
    `]
})
export class FcpopoverComponent extends FcinputComponent {
     /** æ é¢*/
    @Input()
    fcTitle: string;
     /** åå®¹*/
    @Input()
    fcValue: string;
     /** è§¦åæ¹å¼*/
    @Input()
    fcTrigger: string;
     /** æ¯å¦å³é­*/
    @Input()
    fcShowClose: string;
    _showClose :boolean = false;
     /** æ¾ç¤ºä½ç½®*/
    @Input()
    fcPosition: string;
     /**æ°æ³¡å¤§å°*/
    @Input()
    fcSize: string;
     /**æ°æ³¡åå®¹*/
    @Input()
    fcPopoverContent: string ;
     /**owenrcontent*/
    @Input()
    fcType: string ;
     /**å¾æ */
    @Input()
    fcIcon: string ;
     /**æ°æ³¡åå®¹å³é­æ ç­¾*/
    @Input()
    fcPopoverIcon : string ;
    content: any;
    visible : boolean;
    constructor(public provider: ProvidersService) {
        super(provider,'fc-popover');
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
         /**é»è®¤è§¦åæ¹å¼æªhover*/
        if (this.fcTrigger === undefined) {
            this.fcTrigger = "hover";
        }
         /**é»è®¤æ°æ³¡ä¸å¯å³é­*/
        if (this.fcShowClose === undefined) {
            this._showClose = false;
        }
         /**é»è®¤æ¾ç¤ºä½ç½®å¨é¡¶é¨*/
        if (this.fcPosition === undefined) {
            this.fcPosition = "top";
        }
    }
     /**ç¹å»ä¸æ¾ç¤º*/
    clickMe() {
        this.visible  = false;
    }
    _afterParentInit(){
         /**ä¸ºYæ¶å¯å³é­*/
        if(this.fcShowClose === 'Y'){
            this._showClose = true;
        }else{
            this._showClose = false;
        }
    }
}
